<micro-select-combo #sel
              placeholder="Service Type"
              [mode]="mode"
              [(id)]="serviceType"
              (idChange)="change($event)"
              [required]="required"
              [options]="options"
              [disabled]="disabled"
>
</micro-select-combo>
